import BsAvatar from './index.vue'
export default BsAvatar